import PropTypes from 'prop-types'
import classNames from 'classnames'

import { hasCommunity } from '../../utility/userHelper'
import UserMenuTooltip from '../common/UserMenuTooltip'
import AvatarPlaceholder from '../../assets/images/mock/default-profile-icon.png'

import classes from './PortalUserMenu.module.scss'

const PortalUserMenu = ({ user }) => (
  <>
    <div className={classNames(classes.avatarWrapper, 'small-round-image-wrapper ml-auto')} data-for='portalUserTooltip' data-tip>
      <img className='round-image' src={user.avatar?.file_url || AvatarPlaceholder} alt={`${user.first_name} ${user.last_name}`} />
    </div>
    <UserMenuTooltip id='portalUserTooltip' user={user} showDashboard={hasCommunity(user)} />
  </>
)

PortalUserMenu.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number.isRequired,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    avatar: PropTypes.shape({ file_url: PropTypes.string }),
    communities: PropTypes.array,
  }).isRequired,
}

export default PortalUserMenu
